import { Injectable } from '@angular/core';
import { EcommerceTrackingSource } from '@epicuro-next/platform/tracking';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map } from 'rxjs/operators';

import { activateConfigStrip } from '../actions';
import { setEcommerceTrackingSource } from '../actions/config-strip.actions';
import { ConfigStripActivationSource } from '../models';

@Injectable()
export class ConfigStripEcommerceTrackingEffects {
  public setSourceList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(activateConfigStrip),
      filter(
        ({ source }) => source.source === ConfigStripActivationSource.List,
      ),
      map(({ index }) =>
        setEcommerceTrackingSource({
          data: {
            sourceType: EcommerceTrackingSource.List,
            position: index,
          },
        }),
      ),
    ),
  );

  public trackSearchSource$ = createEffect(() =>
    this.actions$.pipe(
      ofType(activateConfigStrip),
      filter(
        ({ source }) => source.source === ConfigStripActivationSource.Search,
      ),
      map(({ index }) =>
        setEcommerceTrackingSource({
          data: {
            sourceType: EcommerceTrackingSource.Search,
            position: index,
          },
        }),
      ),
    ),
  );

  constructor(private actions$: Actions) {}
}
